import React from 'react';

interface StrategyProfileLayoutProps {
  children: React.ReactNode;
}

const StrategyProfileLayout: React.FC<StrategyProfileLayoutProps> = ({
  children,
}) => {
  return (
    <div
      className="flex flex-col gap-6 px-6 py-4 w-full bg-white rounded-lg shadow-sm
        border border-neutral-200 justify-start items-center overflow-hidden"
    >
      {children}
    </div>
  );
};

export default StrategyProfileLayout;
